'use client';

import { __assign, __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useCallback, useEffect } from 'react';
import { ELanguage } from '../Utils/constants.js';
import { getCookie } from '../Utils/cookie.js';
import { getRecommendCompanyList } from './apiServices.js';
import { CompaniesYouWillLoveWrapper, CompaniesList } from './CompaniesYouWillLove.css.js';
import CompanyItem from './CompanyItem/index.js';
import translations from './translation.js';

var DEFAULT_MAX_ITEM_ON_ROW = 2;
var MAX_ITEM_SHOW_NOSIDE = 6;
var MAX_ITEM_SHOW_SIDE = 4;
var DEFAULT_LIMIT_COMPANIES = 12;
var DEFAULT_OPTIONS = {
    maxItemOnRow: DEFAULT_MAX_ITEM_ON_ROW,
    isSideView: false,
    isShowFollow: false,
    limitCompanies: DEFAULT_LIMIT_COMPANIES
};
var CompaniesYouWillLove = function (props) {
    var langCode = props.langCode, _a = props.options, options = _a === void 0 ? DEFAULT_OPTIONS : _a, userId = props.userId, _b = props.jobId, jobId = _b === void 0 ? -1 : _b, accessToken = props.accessToken, _c = props.msUrl, msUrl = _c === void 0 ? 'https://ms.vietnamworks.com' : _c, _d = props.classSelector, classSelector = _d === void 0 ? '' : _d;
    var mergedOption = __assign(__assign({}, DEFAULT_OPTIONS), options);
    var limit = options.isSideView ? MAX_ITEM_SHOW_SIDE : MAX_ITEM_SHOW_NOSIDE;
    var _e = useState(false), isShowList = _e[0], setShowList = _e[1];
    var _f = useState([]), companyList = _f[0], setCompanyList = _f[1];
    var t = useCallback(function (text) {
        if (langCode === ELanguage.EN) {
            return text;
        }
        else {
            return translations[text];
        }
    }, [langCode]);
    var getLastViewJobId = function (userId) {
        var rawCookie = getCookie('VNW_LAST_JOB_SEEN');
        var lastViewCookie = decodeURIComponent(rawCookie !== null ? rawCookie : '');
        if (lastViewCookie) {
            var lastViewJobData = decodeURIComponent(lastViewCookie).split(',');
            var jobId_1 = lastViewJobData[0];
            var userViewJob = lastViewJobData[1] || '-1';
            // not return job Id if logged in user is different than last viewed user
            if (userId !== parseInt(userViewJob)) {
                return null;
            }
            // other than that case, return job Id
            return jobId_1;
        }
        return null;
    };
    var getRecommendCompany = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var lastViewJobId, jobIdStr, API_URL, responseCompany;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (userId === undefined || userId === null || userId === 0) {
                        setShowList(false);
                        return [2 /*return*/];
                    }
                    lastViewJobId = getLastViewJobId(userId);
                    jobIdStr = '';
                    if (jobId !== -1) {
                        jobIdStr = "&jobId=".concat(jobId);
                    }
                    if (jobId === -1 && lastViewJobId !== null) {
                        jobIdStr = "&jobId=".concat(lastViewJobId);
                    }
                    API_URL = "".concat(msUrl, "/smartnavi/v1/companies?user=").concat(userId, "&limit=").concat(mergedOption.limitCompanies).concat(jobIdStr);
                    return [4 /*yield*/, getRecommendCompanyList(API_URL)];
                case 1:
                    responseCompany = _b.sent();
                    if (!((_a = responseCompany === null || responseCompany === void 0 ? void 0 : responseCompany.companies) === null || _a === void 0 ? void 0 : _a.length)) {
                        setShowList(false);
                        return [2 /*return*/];
                    }
                    setCompanyList((responseCompany === null || responseCompany === void 0 ? void 0 : responseCompany.companies) || []);
                    setShowList(true);
                    return [2 /*return*/];
            }
        });
    }); }, [accessToken, jobId, langCode, mergedOption.limitCompanies, msUrl, userId]);
    useEffect(function () {
        getRecommendCompany();
    }, [getRecommendCompany]);
    return (React__default.createElement(React__default.Fragment, null, isShowList && (React__default.createElement(CompaniesYouWillLoveWrapper, { isSideView: options.isSideView || false },
        React__default.createElement("h2", null, t('Companies You Will Love')),
        React__default.createElement(CompaniesList, { maxItemOnRow: options.maxItemOnRow || DEFAULT_MAX_ITEM_ON_ROW }, Array.from(Array(limit), function (_item, index) {
            if (companyList[index] === undefined || companyList[index] === null) {
                return null;
            }
            return (React__default.createElement(CompanyItem, { key: "company-item-".concat(index), t: t, langCode: langCode, companyInfo: companyList[index], accessToken: accessToken, msUrl: msUrl, isShowFollow: options.isShowFollow || false, classSelector: classSelector }));
        }))))));
};

export { DEFAULT_LIMIT_COMPANIES, CompaniesYouWillLove as default };
//# sourceMappingURL=index.js.map
